import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=1b276a20&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=js&"
export * from "./Tasks.vue?vue&type=script&lang=js&"
import style0 from "./Tasks.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Tasks.vue?vue&type=style&index=1&id=1b276a20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b276a20",
  null
  
)

export default component.exports